import React,{Component} from 'react'
import './ResidentQuestions.css'

class ResidentQuestions extends Component{
  render(){
    return(
      <div>
        <h1 className="question-title">{this.props.question.question}</h1>
        <br/>
        {this.props.children}
      </div>
    )
  }
}

export default ResidentQuestions